import React from 'react';

const defaultImpl = {};
export const InstrumentationContext = React.createContext(defaultImpl);



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client-react/packages/hoc-with-instrumentation/src/context.js